import gql from 'graphql-tag';
export const lastExecutedTime = gql `
    query lastExecutedTime {
        dashboardInfo {
            lastExecutionTime
        }
    }
`;
